/**
 * @fileOverview Push data inside window.dataLayer to be read by GTM.
 * @author Theo Suja <theo.suja@selectra.info> - Selectra Front End Team
 */
export default function callBackRequestType(requestType, modalUrl) {
  if ( typeof window.dataLayer !== 'undefined' ){
    window.dataLayer.push({
      event: 'modal',
      data: 'type '+requestType,
      modal_url: modalUrl,
    })
  }
}
